// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"94":"Login","167":"PageNotFound","561":"Dashboard"}[chunkId] || chunkId) + "." + {"91":"f232158d","94":"aca5bed8","167":"75cb33ce","453":"c50bebee","561":"7798107f","635":"c563a75b","710":"688524b0","869":"d70677bd","890":"40d7fe46"}[chunkId] + ".chunk.js";
};